import { render, staticRenderFns } from "./SplitBooking.vue?vue&type=template&id=12f106b2&"
import script from "./SplitBooking.vue?vue&type=script&lang=js&"
export * from "./SplitBooking.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports